import { readonlyTextCell, buttonCell } from "@dashboard/components/Datagrid/customCells/cells";
import { AvailableColumn } from "@dashboard/components/Datagrid/types";
import { Vendors } from "@dashboard/vendors/types";
import { VendorListUrlSortField } from "@dashboard/vendors/urls";
import { getUserName } from "@dashboard/misc";
import { Sort } from "@dashboard/types";
import { getColumnSortDirectionIcon } from "@dashboard/utils/columns/getColumnSortDirectionIcon";
import { GridCell, Item } from "@glideapps/glide-data-grid";
import { IntlShape } from "react-intl";
import { columnsMessages } from "../VendorListDataGrid/messages";

export const vendorListStaticColumnsAdapter = (
  intl: IntlShape,
  sort: Sort<VendorListUrlSortField>,
  includeOrders: boolean,
): AvailableColumn[] =>
  [
    {
      id: "name",
      title: intl.formatMessage(columnsMessages.name),
      width: 450,
    },
    {
      id: "email",
      title: intl.formatMessage(columnsMessages.email),
      width: 450,
    },
    ...(includeOrders
      ? [
          {
            id: "orders",
            title: intl.formatMessage(columnsMessages.orders),
            width: 200,
          },
        ]
      : []),
    {
      id: "actions",
      title: intl.formatMessage(columnsMessages.actions),
      width: 120,
    },
  ].map(column => ({
    ...column,
    icon: getColumnSortDirectionIcon(sort, column.id),
  }));

interface CreateGetCellContentArgs {
  vendors: Vendors | undefined;
  columns: AvailableColumn[];
  onViewVendor?: (id: string) => void;
}

export const createGetCellContent =
  ({ vendors, columns, onViewVendor }: CreateGetCellContentArgs) =>
  ([column, row]: Item): GridCell => {
    const rowData = vendors?.[row];
    const columnId = columns[column]?.id;

    if (!columnId || !rowData) {
      return readonlyTextCell("");
    }

    switch (columnId) {
      case "name":
        return readonlyTextCell(getUserName(rowData) ?? "");
      case "email":
        return readonlyTextCell(rowData?.email ?? "");
      case "orders":
        return readonlyTextCell(rowData?.orders?.totalCount?.toString() ?? "");
      case "actions":
        // Button in the Actions column; you can style it or replace
        // the label with an icon via a custom renderer if desired.
        return buttonCell("View Vendor Info", () => onViewVendor?.(rowData.id));
      default:
        return readonlyTextCell("");
    }
  };
